import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useStation } from '@/store/station';
import { useNoQrcodeOverlay } from "@/store/overlays/no-qr-code-overlay";
import DefaultView from "@/components/views/default-view.vue";
import LoginView from "@/components/views/login-screen.vue";
import ChargeView from "@/components/views/charge/charge-view.vue";

const routes : Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: DefaultView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    beforeEnter: (_to, _from, next) => {
      const station = useStation();
      const no_qrcode_overlay = useNoQrcodeOverlay();
      if (station.qrcode !== null && station.qrcode > 0) {
        next();
        return;
      }
      const last_cp: string | null = localStorage.getItem("last_cp");
      const cached: Record<string, any> = last_cp === null ? null : JSON.parse(last_cp);
      if (cached === null || Date.now() - cached.timestamp > 15 * 60 * 1000) {
        console.log("[login_screen]: forcing noQrCodeOverlay from login_screen.vue");
        next();
        no_qrcode_overlay.show();
      } else {
        next(`/${cached.qr}`);
      }
    }
  },
  {
    path: "/:stationId",
    name: "station",
    component: ChargeView,
    meta: {
      requiresLogin: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
